import React from 'react';

export default function CloseIcon({ rectColor }: { rectColor?: string }): JSX.Element {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.02059 5.60662L11.6168 1.01042C12.0073 0.619898 12.6405 0.619898 13.031 1.01042C13.4215 1.40095 13.4215 2.03411 13.031 2.42464L8.4348 7.02083L13.031 11.617C13.4215 12.0075 13.4215 12.6407 13.031 13.0312C12.6405 13.4218 12.0073 13.4218 11.6168 13.0312L7.02059 8.43504L2.42439 13.0312C2.03387 13.4218 1.4007 13.4218 1.01018 13.0312C0.619654 12.6407 0.619654 12.0075 1.01018 11.617L5.60637 7.02083L1.01018 2.42464C0.619654 2.03411 0.619654 1.40095 1.01018 1.01042C1.4007 0.619898 2.03387 0.619898 2.42439 1.01042L7.02059 5.60662Z'
        fill={rectColor || '#141921'}
      />
    </svg>
  );
}
